import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { RoutingOperation, TId } from 'src/app/models';

@Component({
    selector: 'app-routing-operations-add',
    templateUrl: './routing-operations-add.component.html',
    styleUrl: './routing-operations-add.component.sass',
    standalone: false
})
export class RoutingOperationsAddComponent extends GenericCrudAddComponent<RoutingOperation> {

  @Input() routingId?: TId;
  operationTypes = this.api.resources.operations.operationTypes;
  workProcedures = this.api.resources.product.workProcedures;

  protected override async preFetch(): Promise<void> {
    this.resource = this.api.resources.product.routingOperations(this.routingId!);
  }
  override initFormGroup(): FormGroup<any> {
    const group = this.fb.group({
      name: [],
      operationTypeId:[],
      workProcedureId: [],
      companyId: [this.api.auth.userValue?.lastCompanyId],
    });
    return group;
  }

  async onOperationTypeValueChanged(id: TId) {
    if (!id)
      return;

    const operationType = await firstValueFrom(this.operationTypes.get(id));

    this.form?.patchValue({
      name: operationType.name
    });
  }
}
